import moment from 'moment';
// import _merge from 'lodash-es/merge';
// import _cloneDeep from 'lodash-es/cloneDeep';
// import _mergeWith from 'lodash-es/mergeWith';

export class Utils {
    // static __cloneDeep(a) {
    //     return _cloneDeep(a);
    // }

    // static __mergeWith(a, b,c, d) {
    //     return _mergeWith(a, b, c, d);
    // }

    static isObject(value): boolean {
        if (value === null || value === undefined) {
            return false;
        }
        return value && typeof value === 'object' && !Array.isArray(value);
    }

    static isClassInstance(value): boolean {
        return (
            value !== null &&
            typeof value === 'object' &&
            Object.prototype.toString.call(value) === '[object Object]' &&
            Object.getPrototypeOf(value).constructor !== Object
        );
    }

    // lodash._merge replacement
    static merge(target, ...sources) {
        sources.reduce((acc, src) => {
            Object.keys(src).forEach((key) => {
                if (moment.isMoment(src[key])) {
                    acc[key] = src[key].toDate();
                } else if (src[key] instanceof Date) {
                    acc[key] = new Date(src[key]);
                } else if (Array.isArray(src[key])) {
                    if (!acc[key]) acc[key] = [];
                    src[key].forEach((item, index) => {
                        if (!acc[key][index]) {
                            acc[key][index] = {};
                        }
                        if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
                            Utils.merge(acc[key][index], item);
                        } else {
                            acc[key][index] = item;
                        }
                    });
                } else if (typeof src[key] === 'object' && src[key] !== null) {
                    if (!acc[key]) acc[key] = {};
                    Utils.merge(acc[key], src[key]);
                } else if (src[key] !== undefined) {
                    acc[key] = src[key];
                }
            });
            return acc;
        }, target);
        return target;
    }

    // lodash._mergeWith replacement
    static mergeWith(target, source, customizer) {
        if (typeof customizer !== 'function') {
            throw new Error('Customizer must be a function');
        }

        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                const targetValue = target[key];
                const sourceValue = source[key];

                const customValue = customizer(targetValue, sourceValue, key, target, source);

                if (customValue === undefined) {
                    if (this.isObject(targetValue) && this.isObject(sourceValue)) {
                        target[key] = Utils.mergeWith({ ...targetValue }, sourceValue, customizer);
                    } else {
                        target[key] = sourceValue;
                    }
                } else {
                    target[key] = customValue;
                }
            }
        }
        return target;
    }

    // lodash._cloneDeep replacement
    static cloneDeep(value, visitedObjects = new WeakMap()) {
        if (value === null || value === undefined || typeof value !== 'object') {
            return value;
        }

        if (visitedObjects.has(value)) {
            return visitedObjects.get(value);
        }

        let result;

        if (value instanceof Date) {
            result = new Date(value);
            visitedObjects.set(value, result);
            return result;
        }

        if (value instanceof RegExp) {
            result = new RegExp(value);
            visitedObjects.set(value, result);
            return result;
        }

        if (value instanceof Map) {
            result = new Map();
            visitedObjects.set(value, result);
            value.forEach((val, key) => {
                result.set(key, this.cloneDeep(val, visitedObjects));
            });
            return result;
        }

        if (value instanceof Set) {
            result = new Set();
            visitedObjects.set(value, result);
            value.forEach((val) => {
                result.add(this.cloneDeep(val, visitedObjects));
            });
            return result;
        }

        if (Array.isArray(value)) {
            result = [];
            visitedObjects.set(value, result);
            for (let i = 0; i < value.length; i++) {
                result[i] = this.cloneDeep(value[i], visitedObjects);
            }
            return result;
        }

        if (this.isObject(value)) {
            if (Utils.isClassInstance(value)) {
                result = Object.create(Object.getPrototypeOf(value));
                visitedObjects.set(value, result);
                for (const key in value) {
                    if (Object.prototype.hasOwnProperty.call(value, key)) {
                        result[key] = this.cloneDeep(value[key], visitedObjects);
                    }
                }
                return result;
            }

            result = {};
            visitedObjects.set(value, result);
            for (const key in value) {
                if (Object.prototype.hasOwnProperty.call(value, key)) {
                    result[key] = this.cloneDeep(value[key], visitedObjects);
                }
            }
            return result;
        }

        return value;
    }
}
